import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'

import { ZohoContactSyncSettings } from './ZohoContactSyncSettings'

export const ZohoSpecificSettings = (): ClickNavigationSection[] => {
  return [{ id: 'contactSync', label: 'Contact Sync', content: () => <ZohoContactSyncSettings /> }]
}
